export default "__VITE_ASSET__scf1awCJ__"